import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const SearchResultsContainer = styled.div`
    width: 100%;
    position: relative;

    ${media.mediumDevice`
    width: 100%
    `}
    ${media.mobileDevice`
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        display: flex;
        flex-direction: column;
        position: sticky;
        top: 0;
        height: 100%
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        width: 100%
        margin-bottom: ${(props) =>
            props.physicianFilterOpen & props.physicianSearchOpen
                ? '-5px'
                : 'unset'};
        padding: 0 15px 15px 15px;
    `};
    .message-result-list-container {
        background-color: #ffffff;
    }
    .searchResultsMobile {
        padding: 0px 0px 12px 5px;
        ${media.mobileDevice`
        padding: 0px 8px 12px 5px;
        position: sticky;
        top: 0;
        background: #f5f5f5;
        z-index: 1;
        padding:0;
    `}
    }
    .messageContainerDesktop {
        // padding-left: 20px;
        // padding-bottom: 14px;
    }
`;

export const SearchHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-left: -6px;

    ${media.mobileDevice`
        display: flex;   
        align-items: center;
        // margin-left: -15px;
        // padding-top: 1px;
        padding: 16px;
    `}
`;

export const DemiText = styled.div`
    color: #140f4b;
    font-size: 16px;
    font-family: AvenirNextWorld Demi;
    display: none;
    margin-left: -8px;
    ${media.mobileDevice`
        justify-content: center;
        display: flex;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-right:19px;
        // padding-top: 17px;
        font-size: 20px;
    `}
`;

export const BackButtonContainer = styled.div`
    display: inline-flex;
    margin: ${({ margin }) => (margin ? margin : '0 0 0 10px')};
    // padding-left: 24px;
    // padding-top: 17px;
    width: 100%;

    ${media.mobileDevice`
    width: auto;
    `}
`;

export const BackButtonIcon = styled.img`
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
    margin: ${({ marginMob }) => (marginMob ? marginMob : '0')};
    `}
`;

export const BackText = styled.span`
    margin-left: -10px;
    color: #1010eb;
    font-family: AvenirNextWorld Regular;
    font-size: 16px;

    ${media.mobileDevice`
    // justify-content: center;
    // display: flex;
    display: ${({ mbDisplay }) => mbDisplay && mbDisplay};
    `}
`;

export const TableContainer = styled.div`
    // margin-top: 3%;
    margin-top: 15px;
`;
export const BoldText = styled.span`
    color: #140f4b;
    font-family: AvenirNextWorld Demi;
    font-size: 16px;
`;

export const CloseIconContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    order: 3;
    width: 5%;
    ${media.mobileDevice`
        display: none;
    `}
`;

export const CloseIcon = styled(Icon)`
    width: 22px;
    height: 22px;
    display: block;
    cursor: pointer;
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        justify-content: space-between;
        // position: sticky;
        // bottom:0; 
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(2*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'} 
    `}
`;

export const AccountDetailsContainer = styled.div`
    -webkit-overflow-scrolling: touch;
`;

export const MobileViewPage = styled.div`
    display: none;
    ${media.mobileDevice`
        position: fixed;
        background-color: #FFFFFF;
        box-shadow: 0px -3px 6px #00000014;
        bottom: 0;
        left: 0;
        right: 0;
        display: block;
    `}
`;

export const MobileView = styled.div`
    display: none;

    ${media.mobileDevice`
        display: block;
        width: 100%;
        height: ${(props) => (props.totalResults < 4 ? '100%' : 'unset')};
    `}
`;

export const MobileText = styled.span`
    display: none;
    ${media.mobileDevice`
    display: unset;
    `}
`;

export const DesktopText = styled.span`
    display: unset;
    ${media.mobileDevice`
    display: none;
    `}
`;

export const NoDataTextContainer = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 16px;
    color: #140f4b;
    padding: 8px 5px;
    ${media.mobileDevice`
        padding: 15px 5px;
    `}
`;

export const AccountSearchPaginationContainer = styled.div`
    background-color: #ffffff;
`;

export const PaginationContainer = styled.div`
    position: relative;
    width: 100%;
    bottom: 0;
`;

export const DesktopView = styled.div`
    display: block;

    ${media.mobileDevice`
        display: none;
    `}
`;
